import React from 'react'

const ShopCardIcon = () => (
  <svg
    width='33'
    height='33'
    viewBox='0 0 33 33'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='16.5' cy='16.5' r='15.5' stroke='#2A1846' />
    <path
      d='M16.8762 17.6714H22.7469C23.3938 17.6714 23.9181 17.147 23.9181 16.5001V11.8153C23.9181 11.1684 23.3938 10.644 22.7469 10.644H14.9388C14.292 10.644 13.7676 11.1684 13.7676 11.8153V16.8905'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M18.0146 13.3296C18.4726 12.8759 19.2111 12.8777 19.6669 13.3335C20.1227 13.7893 20.1244 14.5278 19.6708 14.9857'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.7674 12.9866H11.978C11.6143 12.9866 11.2557 13.0712 10.9304 13.2339L10.4735 13.4623C10.075 13.6615 9.74168 13.9702 9.51249 14.3522L8.30176 16.3701'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M9.08252 23.1371L13.5815 21.5115C14.2094 21.2846 14.7481 20.8624 15.1185 20.3069L17.4554 16.8027C17.7953 16.293 17.7281 15.6142 17.2949 15.1811V15.1811C16.7932 14.6793 15.9797 14.6792 15.4778 15.1809L13.7674 16.8906H12.2058'
      stroke='#2A1846'
      strokeWidth='1.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
export default ShopCardIcon
